export const SECTION_CONFIG = {
  payroll: {
    label: "Payroll",
    fields: [
      { key: "pay_period", label: "Pay Period", type: "text" },
      { key: "rate", label: "Salary / Rate", type: "text", sensitive: true },
      { key: "bonuses", label: "Bonuses", type: "text", sensitive: true },
      { key: "deductions", label: "Deductions", type: "text", sensitive: true },
      { key: "net_pay", label: "Net Pay", type: "text", sensitive: true },
      { key: "payment_method", label: "Payment Method", type: "text" },
      { key: "status", label: "Status", type: "text" },
    ],
    columns: ["pay_period", "rate", "net_pay", "payment_method", "status"],
  },
  benefits: {
    label: "Benefits",
    fields: [
      { key: "benefit_type", label: "Benefit Type", type: "text" },
      { key: "provider", label: "Provider / Vendor", type: "text" },
      { key: "coverage", label: "Coverage Details", type: "textarea" },
      { key: "start_date", label: "Start Date", type: "date" },
      { key: "end_date", label: "End Date", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Expired"] },
    ],
    columns: ["benefit_type", "provider", "start_date", "end_date", "status"],
  },
  attendance: {
    label: "Attendance",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "time_in", label: "Time In", type: "time" },
      { key: "time_out", label: "Time Out", type: "time" },
      { key: "overtime", label: "Overtime (hrs)", type: "text" },
      { key: "remarks", label: "Remarks", type: "text" },
    ],
    columns: ["date", "time_in", "time_out", "overtime", "remarks"],
  },
  performance: {
    label: "Performance",
    fields: [
      { key: "evaluation_date", label: "Evaluation Date", type: "date" },
      { key: "score", label: "Performance Score", type: "text" },
      { key: "reviewer", label: "Reviewer", type: "text" },
      { key: "comments", label: "Reviewer Comments", type: "textarea" },
    ],
    columns: ["evaluation_date", "score", "reviewer", "comments"],
  },
  training: {
    label: "Training",
    fields: [
      { key: "program_name", label: "Program Name", type: "text" },
      { key: "provider", label: "Provider", type: "text" },
      { key: "completion_date", label: "Completion Date", type: "date" },
      { key: "certification_status", label: "Certification Status", type: "select", options: ["Completed", "In Progress", "Certified", "Expired"] },
    ],
    columns: ["program_name", "provider", "completion_date", "certification_status"],
  },
};

export const CORE_GROUPS = [
  {
    title: "Personal Information",
    fields: [
      { key: "full_name", label: "Full Name", type: "text" },
      { key: "date_of_birth", label: "Date of Birth", type: "date" },
      { key: "personal_email", label: "Personal Email", type: "text", sensitive: true },
      { key: "mobile", label: "Mobile / Contact", type: "text", sensitive: true },
      { key: "address", label: "Address", type: "textarea", sensitive: true },
    ],
  },
  {
    title: "Emergency Contact",
    fields: [
      { key: "emergency_contact_name", label: "Contact Name", type: "text" },
      { key: "emergency_contact_relation", label: "Relationship", type: "text" },
      { key: "emergency_contact_phone", label: "Contact Phone", type: "text", sensitive: true },
    ],
  },
  {
    title: "Government IDs",
    lock: true,
    fields: [
      { key: "sss", label: "SSS", type: "text", sensitive: true },
      { key: "philhealth", label: "PhilHealth", type: "text", sensitive: true },
      { key: "pagibig", label: "Pag-IBIG", type: "text", sensitive: true },
      { key: "tin", label: "TIN", type: "text", sensitive: true },
    ],
  },
  {
    title: "Job Details",
    fields: [
      { key: "job_title", label: "Job Title", type: "text" },
      { key: "department", label: "Department", type: "text" },
      { key: "manager", label: "Manager", type: "text" },
      { key: "employment_type", label: "Employment Type", type: "select", options: ["Regular", "Probationary", "Contractual", "Part-time"] },
      { key: "hire_date", label: "Hire Date", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Active", "On Leave", "Resigned", "Terminated"] },
    ],
  },
];
